import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import lazyWithRetry from './utils/lazyWithRetry';
import RouteErrorBoundary from './components/RouteErrorBoundary';
import AnalyticsListener from './components/AnalyticsListener';
// `/` paints without a chunk fetch, as on the counseling product.
import LandingPage from './pages/LandingPage';
const BuilderPage = lazyWithRetry(() => import('./pages/BuilderPage'), 'BuilderPage');
const RunsPage = lazyWithRetry(() => import('./pages/RunsPage'), 'RunsPage');
const RunPage = lazyWithRetry(() => import('./pages/RunPage'), 'RunPage');
const PrivacyPage = lazyWithRetry(() => import('./pages/PrivacyPage'), 'PrivacyPage');
const TermsPage = lazyWithRetry(() => import('./pages/TermsPage'), 'TermsPage');
const NotFoundPage = lazyWithRetry(() => import('./pages/NotFoundPage'), 'NotFoundPage');

function ScrollToTop() {
  // A route change scrolls to the top; a hash (the footer's links into landing sections) scrolls to
  // that element once its page has rendered (reviewer, PR #29: a client-side hash link moved nothing).
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return undefined; }
    const id = setTimeout(() => { const el = document.getElementById(hash.slice(1)); if (el) el.scrollIntoView(); else window.scrollTo(0, 0); }, 0);
    return () => clearTimeout(id);
  }, [pathname, hash]);
  return null;
}

function RouteFallback() {
  return <div className="wrap" style={{ padding: '48px 28px', color: 'var(--muted)' }}>Loading</div>;
}

export default function App() {
  return (
    <RouteErrorBoundary>
      <Router>
        <ScrollToTop />
        <AnalyticsListener />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/app" element={<BuilderPage />} />
            <Route path="/runs" element={<RunsPage />} />
            <Route path="/runs/:id" element={<RunPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </Router>
    </RouteErrorBoundary>
  );
}
